import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { column, row } from './commonCSS';
import { css } from '@emotion/react';

const fadeOutStyle = css`
	@keyframes fadeOut {
		0% {
			transform: translateX(0px);
		}
		100% {
			transform: translateX(-10px);
		}
	}
	animation-iteration-count: 4;
	animation-direction: alternate;
	animation-name: fadeOut;
	animation-duration: 0.1s;
	animation-timing-function: ease-in-out;
	animation-fill-mode: forwards;
`;

function TextField2FA({
	value,
	setValue,
	showIsInvalid,
	setShowIsInvalid,
	onClick,
	sx = {}
}) {
	return (
		<Box sx={[...(Array.isArray(sx) ? sx : [sx]), row]}>
			<Box sx={column}>
				<TextField
					value={value}
					onClick={e => {
						setShowIsInvalid(false);
					}}
					onChange={e => {
						if (e.target.value.match(/^\d{0,6}$/) !== null) {
							setValue(e.target.value);
						}
					}}
					sx={{
						mr: 2
					}}
					color={showIsInvalid ? 'error' : 'primary'}
				/>
				{showIsInvalid && (
					<Box
						sx={fadeOutStyle}
						onClick={e => {
							setShowIsInvalid(false);
						}}
						sx={{
							width: 'fit-content',
							color: 'red',
							borderRadius: '2px',
							padding: '2px 4px'
						}}>
						<Typography variant="body2">
							The code is invalid!
						</Typography>
					</Box>
				)}
			</Box>
            <Button
				onClick={onClick}
				variant="outlined"
				disabled={value.length < 6}>
				FINISH
			</Button>
        </Box>
    );
}

export default TextField2FA;
